import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const WaitingCard = styled.div<{ windowWidth: number }>`
  display: flex;
  position: relative;
  justify-content: space-between;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
  margin-bottom: 0.5em;
  padding: 16px;
  flex-direction: ${({ windowWidth }) =>
    windowWidth < 800 ? 'column' : 'row'};
  align-items: ${({ windowWidth }) =>
    windowWidth < 800 ? 'center' : 'center'};
`

export const CardTitle = styled.div`
  font-weight: 300;
  font-size: 1.2em;
  margin-bottom: 0.4em;
  margin-left: 0.5em;
  max-width: 114px;
`

export const CardDescription = styled.div`
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.4);
  margin-left: 0.7em;
  margin-top: 0.5em;
  max-width: 114px;
`

export const ActivityMenuIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`

export const ActivityMenuWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`

export const MenuWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`

export const ActivityMenuHeading = styled.div<{
  windowWidth: number
}>`
  max-width: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const MenuText = styled.p`
  margin: 0;
  font-weight: 500;
`

export const ActivityMenuText = styled.p<{ windowWidth: number }>`
  margin: 0;
  font-weight: 500;
`

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ActionButton = styled.button`
  color: #2164db;
  background-color: #dee1e7;
  border-radius: 29px;
  padding: 8px 10px;
  margin-left: 5px;
  border: none;
  height: 45px;
  width: 45px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #2164db;
    color: #ffffff;
    cursor: pointer;
  }
`

export const DeleteWrapper = styled.div`
  background-color: rgba(210, 68, 68, 0.8) !important;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  flex-direction: column;
  left: 0;
` 
